import deepFreeze from 'deep-freeze';
import cloneDeep from 'lodash/cloneDeep';

export default function readonly (obj) {
    return deepFreeze(cloneDeep(obj));
}

